// extracted by mini-css-extract-plugin
export default {"actionButton":"Dialog_actionButton__iXpnZ","cancel":"Dialog_cancel__whXaW"};